import React from "react";
import PredictionPage from "../../components/PredictionPage";

function US500() {
  return (
    <PredictionPage
      title="US500"
      content="This is the US500 AI Trading Predictions page."
      canonical="/indices/us500-ai-trading-predictions"
      categoryKey="nav.indices"
      categoryPath="/indices"
      symbol="US500"
    />
  );
}

export default US500;
